export class ConflictDialogData {
  public confirmationText: string;
  public dialogTitle: string;
  public htmlText?: boolean;
}
